<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » YouTube埋め込みコードダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>YouTube埋め込みコードダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/youtube-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> YouTube埋め込みコード
        </div>
        <div class="manual-explain">
          YouTube埋め込みコードを設定します。<br>
          言語ごとに埋め込みコードを設定可能です。<br>
          <span class="manual-explain-notes">※システムの都合上、iframe のサイズを 90% で設定（width="90%" height="90%"）してください。</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Top</a> » Description of YouTube Embed Code Dialog
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Description of YouTube Embed Code Dialog</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_youtube-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any changes made will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> YouTube Embed Code
        </div>
        <div class="manual-explain">
          Set the YouTube embed code.<br>
          Embed codes can be set for each language.<br>
          <span class="manual-explain-notes">
            ※Due to system requirements, set the iframe size to 90% (width="90%" height="90%").
          </span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to save the changes made.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>